<template>
  <el-dialog
    :title="isAdd ? $t('evBike.addBike') : $t('evBike.editBike')"
    :visible.sync="visible"
    width="600px"
    @close="resetForm">
    <el-form :model="form" label-width="120px" ref="evBikeForm">
      <el-form-item :label="$t('evBike.ownerName')" required>
        <el-select
          v-model="selectedOwnerKey"
          :placeholder="$t('evBike.inputOwnerName')"
          style="width: 100%"
          filterable
          allow-create
          default-first-option
          clearable
          :loading="ownerOptionsLoading"
          @change="handleOwnerChange">
          <el-option
            v-for="option in ownerOptions"
            :key="option.key"
            :label="option.name"
            :value="option.key">
            <span>{{ option.name }}</span>
            <span v-if="option.isOwner" style="margin-left: 6px; color: #909399;">({{ $t('evBike.ownerTypeOwner') }})</span>
            <span v-if="option.phone" style="margin-left: 6px; color: #909399;">{{ option.phone }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('evBike.ownerPhone')" required>
        <el-input
          v-model="form.ownerPhone"
          :placeholder="$t('evBike.inputOwnerPhone')"
          maxlength="11" />
      </el-form-item>

      <el-form-item :label="$t('evBike.plateNumber')">
        <el-input
          v-model="form.plateNumber"
          :placeholder="$t('evBike.inputPlateNumber')"
          maxlength="20" />
      </el-form-item>

      <el-form-item :label="$t('evBike.brandModel')">
        <el-input
          v-model="form.brandModel"
          :placeholder="$t('evBike.inputBrandModel')"
          maxlength="100" />
      </el-form-item>

      <el-form-item :label="$t('evBike.state')">
        <el-select v-model="form.state" :placeholder="$t('evBike.selectState')" style="width: 100%">
          <el-option :label="$t('evBike.stateNormal')" value="1001"></el-option>
          <el-option :label="$t('evBike.stateDisable')" value="2002"></el-option>
          <el-option :label="$t('evBike.stateLost')" value="3003"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('evBike.remark')">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          :placeholder="$t('evBike.inputRemark')"
          maxlength="500" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm" :loading="loading">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveEvBike, updateEvBike } from '@/api/evbike/evBikeApi'
import { queryOwnerMembers } from '@/api/simplify/simplifyOwnerMemberApi'

export default {
  name: 'EditEvBike',
  data() {
    return {
      visible: false,
      loading: false,
      isAdd: true,
      form: {
        bikeId: '',
        plateNumber: '',
        brandModel: '',
        ownerName: '',
        ownerPhone: '',
        cardNumber: '',
        userId: '',
        ownerId: '',
        communityId: '',
        state: '1001',
        remark: ''
      },
      communityId: '',
      ownerOptions: [],
      ownerOptionsLoading: false,
      selectedOwnerKey: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(info) {
      this.isAdd = info.isAdd !== false

      if (this.isAdd) {
        this.form = {
          bikeId: '',
          plateNumber: '',
          brandModel: '',
          ownerName: '',
          ownerPhone: '',
          cardNumber: '',
          userId: '',
          ownerId: info.ownerId || '',
          communityId: this.communityId,
          state: '1001',
          remark: ''
        }
      } else {
        this.form = {
          bikeId: info.bikeId || '',
          plateNumber: info.plateNumber || '',
          brandModel: info.brandModel || '',
          ownerName: info.ownerName || '',
          ownerPhone: info.ownerPhone || '',
          cardNumber: info.cardNumber || '',
          userId: info.userId || '',
          ownerId: info.ownerId || '',
          communityId: info.communityId || this.communityId,
          state: info.state || '1001',
          remark: info.remark || ''
        }
      }

      this.selectedOwnerKey = this.form.ownerName || ''
      this.ownerOptions = []
      this.visible = true
      const ownerOptionName = info.roomOwnerName || (this.isAdd ? info.ownerName : '')
      const ownerOptionPhone = info.roomOwnerPhone || (this.isAdd ? info.ownerPhone : '')
      this.loadOwnerOptions(
        this.form.ownerId || info.ownerId || '',
        ownerOptionName,
        ownerOptionPhone
      )
    },

    validateForm() {
      if (!this.form.ownerName) {
        this.$message.warning(this.$t('evBike.ownerNameRequired'))
        return false
      }
      if (!this.form.ownerPhone) {
        this.$message.warning(this.$t('evBike.ownerPhoneRequired'))
        return false
      }
      // 验证手机号格式
      if (this.form.ownerPhone && !/^1[3-9]\d{9}$/.test(this.form.ownerPhone)) {
        this.$message.warning(this.$t('evBike.ownerPhoneInvalid'))
        return false
      }
      return true
    },

    async submitForm() {
      if (!this.validateForm()) return

      this.loading = true
      try {
        if (this.isAdd) {
          await saveEvBike(this.form)
        } else {
          await updateEvBike(this.form)
        }

        this.$message.success(this.$t('common.operationSuccess'))
        this.$emit('listEvBikeData')
        this.visible = false
      } catch (error) {
        this.$message.error(error.message || this.$t('evBike.saveError'))
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      if (this.$refs.evBikeForm) {
        this.$refs.evBikeForm.resetFields()
      }
      this.ownerOptions = []
      this.ownerOptionsLoading = false
      this.selectedOwnerKey = ''
    },

    handleOwnerChange(value) {
      if (!value) {
        this.form.ownerName = ''
        this.form.ownerPhone = ''
        this.selectedOwnerKey = ''
        return
      }

      const selected = this.ownerOptions.find(option => option.key === value)
      if (selected) {
        this.form.ownerName = selected.name
        this.form.ownerPhone = selected.phone || ''
        return
      }

      // Allow manual entries created via allow-create
      this.form.ownerName = value
      this.form.ownerPhone = ''
    },

    async loadOwnerOptions(ownerId, ownerName, ownerPhone) {
      const seenDisplayKeys = new Set()
      const options = []
      const mergeOptionIfPossible = (name, phone) => {
        if (!name) return false
        const normalizedPhone = phone || ''
        const existing = options.find(option => option.name === name)
        if (!existing) return false
        if (existing.phone && normalizedPhone && existing.phone !== normalizedPhone) {
          return false
        }
        if (!existing.phone && normalizedPhone) {
          existing.phone = normalizedPhone
        }
        return true
      }
      const appendOption = ({ key, name, phone, isOwner }) => {
        if (!name) return
        const normalizedPhone = phone || ''
        const displayKey = `${name}-${normalizedPhone}`
        if (seenDisplayKeys.has(displayKey)) return
        seenDisplayKeys.add(displayKey)
        const optionKey = key || `${isOwner ? 'owner' : 'member'}-${displayKey}`
        options.push({
          key: optionKey,
          name,
          phone: normalizedPhone,
          isOwner: !!isOwner
        })
      }

      if (ownerName) {
        appendOption({
          key: `owner-${ownerId || ownerName}`,
          name: ownerName,
          phone: ownerPhone,
          isOwner: true
        })
      }

      if (this.form.ownerName && this.form.ownerName !== ownerName) {
        appendOption({
          key: `current-${this.form.ownerName}-${this.form.ownerPhone || ''}`,
          name: this.form.ownerName,
          phone: this.form.ownerPhone
        })
      }

      this.ownerOptions = options.slice()
      this.syncSelectedOwnerKey()

      if (!ownerId) {
        this.syncOwnerPhoneFromSelection()
        return
      }

      this.ownerOptionsLoading = true
      try {
        const res = await queryOwnerMembers({
          page: 1,
          row: 50,
          ownerId,
          communityId: this.communityId
        })

        if (Array.isArray(res.data)) {
          res.data.forEach(member => {
            const normalizedPhone = member.link || ''
            if (mergeOptionIfPossible(member.name, normalizedPhone)) {
              return
            }
            appendOption({
              key: `member-${member.memberId || member.objId || member.userId || member.id || member.name}`,
              name: member.name,
              phone: normalizedPhone,
              isOwner: false
            })
          })
        }
      } catch (error) {
        this.$message.error(error.message || this.$t('evBike.ownerOptionsLoadFailed'))
      } finally {
        this.ownerOptions = options
        this.ownerOptionsLoading = false
        this.syncSelectedOwnerKey()
        this.syncOwnerPhoneFromSelection()
      }
    },

    syncSelectedOwnerKey() {
      if (!this.form.ownerName) {
        this.selectedOwnerKey = ''
        return
      }

      const matched = this.ownerOptions.find(option => option.name === this.form.ownerName && (!option.phone || option.phone === this.form.ownerPhone || !this.form.ownerPhone))
      if (matched) {
        this.selectedOwnerKey = matched.key
      } else {
        this.selectedOwnerKey = this.form.ownerName
      }
    },

    syncOwnerPhoneFromSelection() {
      if (this.form.ownerPhone) {
        return
      }

      const matched = this.ownerOptions.find(option => option.key === this.selectedOwnerKey)
      if (matched && matched.phone) {
        this.form.ownerPhone = matched.phone
      }
    }
  }
}
</script>
